console.log('%c[TopFeed] main.js loaded', 'color: green; font-weight: bold;');

import './module/sw-category/component/sw-category-view/index';
import './view/category-detail-topfeed';
import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Module.register('tab-top-feed-category-settings', {
    routeMiddleware(next, currentRoute) {
        if (currentRoute.name === 'sw.category.detail') {
            currentRoute.children.push({
                name: 'sw.category.detail.topfeed',
                path: '/sw/category/index/:id/topfeed',
                component: 'category-detail-topfeed',
                meta: {
                    parentPath: "sw.category.index"
                }
            });
        }
        next(currentRoute);
    },
    
        snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },
});
